import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import {
  addAllListPools,
  setAllPoolsStatusLoading,
} from '../../modules/listPools/actions'
import { fetchAllPools } from '../../utils/pools'

const useFetchAndStoreAllPoolsData = () => {
  const dispatch = useDispatch()

  const dispatchAllPoolsToStore = useCallback(
    async (
      search: string,
      limit: number,
      offset: number,
      status: string,
      sort: string,
    ) => {
      try {
        dispatch(setAllPoolsStatusLoading(true))

        const { pools, total } = await fetchAllPools(
          search,
          limit,
          offset,
          status,
          sort,
        )

        dispatch(addAllListPools(pools, total))
      } catch (error) {
        console.error(error)
      } finally {
        dispatch(setAllPoolsStatusLoading(false))
      }
    },
    [dispatch],
  )

  return dispatchAllPoolsToStore
}

export default useFetchAndStoreAllPoolsData
